import { ReactNode } from 'react';

import { HStack, Separator, Skeleton, StatHelpText, StatLabel, StatRoot, StatValueText } from '../../chakra';
import { NON_BREAKING_SPACES } from '../constants';

export interface StatItem<T> {
  label: ReactNode;
  value: (value: T) => ReactNode;
  helpText?: (value: T) => ReactNode;
  'data-testid'?: string;
}

export interface StatsHeaderProps<T> {
  entity?: T;
  isLoading?: boolean;
  stats: StatItem<T>[];
}

export function StatsHeader<T>({ entity, stats, isLoading }: StatsHeaderProps<T>) {
  return (
    <HStack gap={6} separator={<Separator orientation="vertical" height="24" />} justifyContent="flex-start">
      {stats.map((stat, index) => (
        <StatRoot key={index} data-testid={stat['data-testid']}>
          <StatLabel>{stat.label}</StatLabel>
          <StatValueText>
            {isLoading || !entity ? <Skeleton>{NON_BREAKING_SPACES}</Skeleton> : stat.value(entity)}
          </StatValueText>
          {stat.helpText ? (
            <StatHelpText data-testid="stat-help">
              {isLoading || !entity ? <Skeleton /> : stat.helpText(entity)}
            </StatHelpText>
          ) : null}
        </StatRoot>
      ))}
    </HStack>
  );
}
